import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomainsService } from '@app/modules/domains/domains.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { catchError, finalize, of } from 'rxjs';

@Component({
  selector: 'sbnb-unlinked-managed-domain-meta',
  templateUrl: './unlinked-managed-domain-meta.component.html',
  styleUrl: './unlinked-managed-domain-meta.component.scss',
})
export class UnlinkedManagedDomainMetaComponent {
  @Input() hideElevation = false;
  @Input() domainUuid: string;
  @Input() domainName: string;
  @Output() domainVerified = new EventEmitter<void>();
  verifying = false;
  nameservers = ['ns1.hsptbl.com', 'ns2.hsptbl.com', 'ns3.hsptbl.com', 'ns4.hsptbl.com'];

  constructor(
    private domainsService: DomainsService,
    private toast: ToastNotificationsService
  ) {}

  triggerVerification(): void {
    if (!this.domainUuid) return;

    this.verifying = true;

    this.domainsService
      .verifyDomainDnsRecords(this.domainUuid)
      .pipe(
        finalize(() => (this.verifying = false)),
        catchError((error) => {
          console.error('Error verifying domain DNS:', error);
          this.toast.error('Failed to verify domain configuration. Please try again.');
          return of(null);
        })
      )
      .subscribe((response) => {
        if (response?.success) {
          this.toast.success('Domain configuration verified successfully');
          this.domainVerified.emit();
        } else {
          this.toast.error(
            'Domain configuration not yet complete. If you recently changed settings, please wait a few minutes and try again.'
          );
        }
      });
  }
}
